/** Formatação para pré-visualização NFS-e (homologação / mock visual). */

export function maskCpfCnpjDigits(raw: string): string {
  const d = String(raw ?? '').replace(/\D/g, '');
  if (d.length <= 11) {
    const p1 = d.slice(0, 3);
    const p2 = d.slice(3, 6);
    const p3 = d.slice(6, 9);
    const p4 = d.slice(9, 11);
    let o = p1;
    if (p2) o += `.${p2}`;
    if (p3) o += `.${p3}`;
    if (p4) o += `-${p4}`;
    return o;
  }
  return maskCnpjDigits(d);
}

export function maskCnpjDigits(d: string): string {
  const digits = d.replace(/\D/g, '').slice(0, 14);
  const p1 = digits.slice(0, 2);
  const p2 = digits.slice(2, 5);
  const p3 = digits.slice(5, 8);
  const p4 = digits.slice(8, 12);
  const p5 = digits.slice(12, 14);
  let o = p1;
  if (p2) o += `.${p2}`;
  if (p3) o += `.${p3}`;
  if (p4) o += `/${p4}`;
  if (p5) o += `-${p5}`;
  return o;
}

export function maskCep(s: string): string {
  const d = String(s ?? '')
    .replace(/\D/g, '')
    .slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

/** YYYY-MM → MM/YYYY */
export function billingPeriodToCompetenciaLabel(bp: string): string {
  const m = String(bp ?? '')
    .trim()
    .match(/^(\d{4})-(\d{2})/);
  if (!m) return bp || '—';
  return `${m[2]}/${m[1]}`;
}

/** Valor em centavos (número) → "709,00" */
export function formatBrlCsv(cents: number): string {
  const n = Math.abs(Math.round(Number(cents) || 0)) / 100;
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Hash estável → string numérica longa (mock de identificador). */
export function stableNumericIdFromString(seed: string, len: number): string {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (h << 5) - h + seed.charCodeAt(i);
    h |= 0;
  }
  const out: string[] = [];
  let x = Math.abs(h) + 2147483647;
  for (let i = 0; i < len; i += 1) {
    x = (x * 1103515245 + 12345) & 0x7fffffff;
    out.push(String(x % 10));
  }
  return out.join('');
}

export function chunkIdentificadorDisplay(s: string, group = 4): string {
  const d = s.replace(/\D/g, '');
  const parts: string[] = [];
  for (let i = 0; i < d.length; i += group) {
    parts.push(d.slice(i, i + group));
  }
  return parts.join(' ');
}
